import { Action, createReducer, on } from '@ngrx/store';
import { SearchTermMapDto } from '@shared/models/config/search-term-map.dto';
import { OrderByMapDto } from 'src/shared/models/config/order-by-map.dto';
import { PageSizeMapDto } from 'src/shared/models/config/page-size-map.dto';
import { SortTypeMapDto } from 'src/shared/models/config/sort-type-map.dto';
import {
  setOrderByFailure,
  setOrderBySuccess,
  setPageSizeFailure,
  setPageSizeSuccess,
  setSearchTermFailure,
  setSearchTermSuccess,
  setSortTypeFailure,
  setSortTypeSuccess
} from './tables.actions';

export interface State {
  pageSize?: PageSizeMapDto[];
  sort?: OrderByMapDto[];
  sortType?: SortTypeMapDto[];
  searchTerm?: SearchTermMapDto[];
}

export const initialState: State = {};

const tablesReducer = createReducer(
  initialState,

  on(setPageSizeSuccess, (state, { data }) => setPageSizes(state, data)),
  on(setPageSizeFailure, (state) => setPageSizes(state, null)),

  on(setOrderBySuccess, (state, { data }) => setOrderBy(state, data)),
  on(setOrderByFailure, (state) => setOrderBy(state, null)),

  on(setSortTypeSuccess, (state, { data }) => setSortType(state, data)),
  on(setSortTypeFailure, (state) => setSortType(state, null)),

  on(setSearchTermSuccess, (state, { data }) => setSearchTerm(state, data)),
  on(setSearchTermFailure, (state) => setSearchTerm(state, null))
);

function setPageSizes(state: State, pageSize: any) {
  return {
    ...state,
    pageSize,
  };
}

function setOrderBy(state: State, sort: any) {
  return {
    ...state,
    sort,
  };
}

function setSortType(state: State, sortType: any) {
  return {
    ...state,
    sortType,
  };
}

function setSearchTerm(state: State, searchTerm: any) {
  return {
    ...state,
    searchTerm,
  };
}

function setSelectedStatuses(state: State, selectedStatuses: any) {
  return {
    ...state,
    selectedStatuses,
  };
}

export function reducer(state: State | undefined, action: Action) {
  return tablesReducer(state, action);
}
